import { Controller } from "@hotwired/stimulus"

// Toggles between "Upload a new file" and "Use a startup PRD" inputs on the
// Competitive Analysis and Economic Intelligence forms. Mounted via
// data-controller="prd-source".
export default class extends Controller {
  static targets = ["radio", "uploadField", "startupField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.radioTargets.find(r => r.checked)?.value || "upload"

    if (selected === "startup") {
      this.uploadFieldTarget.classList.add("hidden")
      this.startupFieldTarget.classList.remove("hidden")
      this.setRequired(this.uploadFieldTarget, false)
      this.setRequired(this.startupFieldTarget, true)
    } else {
      this.uploadFieldTarget.classList.remove("hidden")
      this.startupFieldTarget.classList.add("hidden")
      this.setRequired(this.uploadFieldTarget, true)
      this.setRequired(this.startupFieldTarget, false)
    }
  }

  setRequired(container, required) {
    container.querySelectorAll("input, select, textarea").forEach(el => {
      if (required) {
        el.setAttribute("required", "required")
      } else {
        el.removeAttribute("required")
      }
    })
  }
}
